import axios from "axios";
import { domain } from "../Constants";
import Service from "../Service";

const collection = {
  getCollectionById(data) {
    // page=${data.page}&
    return axios({
      url: `${domain}api/collections?page=${data.page}&category_collection_id=${data.id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get collection\n", e.message);
      return { status: e.response.status };
    });
  },
  getMoreCollection(data) {
    return axios({
      url: `${domain}api/get-collection-more?page=${data.page}&category_collection_id=${data.id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get collection\n", e.message);
      return { status: e.response.status };
    });
  },
  getCategoryCollection() {
    return axios({
      url: `${domain}api/category-collection`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get category collection\n", e.message);
      return { status: e.response.status };
    });
  },
  getCollectionPortfolio(data) {
    return axios({
      // url: `${domain}api/collection-portfolio?page=${data.page}&&id=${data.id}&&type=${data.type}`,
      url: `${domain}api/collection-portfolio?page=${data.page}&&id=${data.id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get category collection\n", e.message);
      return { status: e.response.status };
    });
  },
  getMoreCollectionPortfolio(data) {
    return axios({
      url: `${domain}api/get-more-collection-portfolio?page=${data.page}&&id=${data.id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get category collection\n", e.message);
      return { status: e.response.status };
    });
  },
  onGetCollectionById(id) {
    return Service.get("api/get-collection-by-id?id=" + id);
  },
  getCreatorPortfolio() {
    return Service.get("api/get-creator-portfolio");
  },
  getCollectionoHighlight() {
    return Service.get("api/get-collection-highlight");
  },
};

export default collection;
